module.exports = __webpack_public_path__ + "static/media/novi-isb-logo1.a5546d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/novi-isb-logo1.png
// module id = 736
// module chunks = 3